/* Cité Érotik — product media gallery Web Component */
(function () {
  'use strict';

  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.medias = Array.from(this.querySelectorAll('[data-media]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(thumb.dataset.thumb));
      });

      this.addEventListener('variant:change', (e) => this.show(String(e.detail.mediaId)));
    }

    show(mediaId) {
      this.medias.forEach((m) => m.classList.toggle('hidden', m.dataset.media !== mediaId));
      this.thumbs.forEach((t) => {
        var active = t.dataset.thumb === mediaId;
        t.classList.toggle('border-primary', active);
        t.classList.toggle('border-transparent', !active);
      });
    }
  }
  if (!customElements.get('media-gallery')) customElements.define('media-gallery', MediaGallery);
})();
